<template>
  <div class="index">
    <div id="loader-wrapper" v-if="isLoading">
      <div id="loader"></div>

      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
    </div>
    <!-- HEADER -->
    <b-container fluid class="header-tag">
      <TopMenu />
      <HeaderContent :content="contentHeader" link="/product/7/pms" :img="content.header_image" left="4" right="8" />
    </b-container>
    <!-- HEADER -->

    <!-- CONTENT 1 -->
    <ContentBoxWhiteTop :contentTop="contentSubHeader1" :contentBottom="contentSubHeader2" />
    <!-- CONTENT 1 -->

    <!-- CONTENT 2 -->
    <ContentBoxBlue :content="contentPMS" link="/product/7/pms" />
    <!-- CONTENT 2 -->

    <!-- CONTENT 3 -->
    <ContentBoxGrey :content="contentGoogleWorkspace" link="/product/5/google-workspace" />
    <!-- CONTENT 3 -->

    <!-- CONTENT 4 -->
    <ContentBoxWhite :content="contentChannelManager" link="/product/6/channel-manager" />
    <!-- CONTENT 4 -->

    <!-- CONTENT 5 -->
    <ContentBoxBlue :content="contentBookingEngine" link="/product/4/booking-engine" />
    <!-- CONTENT 5 -->

    <!-- CONTENT 6 -->
    <ContentBoxWhiteBottom :content="contentCloudServer" link="/product/8/cloud-server" />
    <!-- CONTENT 6 -->

    <!-- CONTENT 7 -->
    <ContentBoxBlueDark :content="contentNetwork" />
    <!-- CONTENT 7 -->
    <lazy-background class="content-box-company" :size="lazybg.size" :position="lazybg.position"
      src="https://www.sentineltech.com/assets/images/CompanyOverviewNew.png">
      <div slot="content">
        <ContentBoxCompany :content="contentCompany" />
      </div>
    </lazy-background>

    <!-- CONTENT 7 -->
    <!--b-container fluid class="content-box-company">
      <b-container id="about-us">
        <b-row class="content-section text-center">
          <b-col
            cols="12"
            class="content-area"
            v-animate-onscroll="'animated zoomIn'"
          >
            <b-img-lazy
              v-bind="smallcontentProps"
              :src="contentcompany.content_image"
              :alt="contentcompany.content_title"
            ></b-img-lazy>
            <h2 v-html="contentcompany.content_title"></h2>
            <div v-html="contentcompany.content_description"></div>
            <div class="content-button">
              <b-button to="/contact-us/submit" class="btn-magenta">{{
                $store.state.labels.LABEL_READY
              }}</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-container-->
    <!-- CONTENT 7 -->

    <!-- CONTENT 8 -->
    <ContentBoxWhiteFooter :partners="partners" />
    <!-- CONTENT 8 -->
    <Footer v-if="footer" :contents="footer" />
  </div>
</template>

<script>

import { AppService } from './../service/main'
import TopMenu from "@/components/TopMenu.vue";
import Footer from "@/components/Footer.vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ContentBoxWhiteTop from "@/components/ContentBoxWhiteTop.vue";
import ContentBoxBlue from "@/components/ContentBoxBlue.vue";
import ContentBoxGrey from "@/components/ContentBoxGrey.vue";
import ContentBoxWhite from "@/components/ContentBoxWhite.vue";
import ContentBoxWhiteBottom from "@/components/ContentBoxWhiteBottom.vue";
import ContentBoxBlueDark from "@/components/ContentBoxBlueDark.vue";
import ContentBoxCompany from "@/components/ContentBoxCompany.vue";
import ContentBoxWhiteFooter from "@/components/ContentBoxWhiteFooter.vue";

export default {
  name: "Index",
  metaInfo() {
    return {
      title: `${this.content.m_title}`,
      link: [
        {
          rel: "canonical",
          href: "https://www.sentineltech.com" + `${this.$route.fullPath}`,
        },
      ],
      meta: [
        {
          name: "description",
          content: `${this.content.m_description}`,
        },
        { property: "og:title", content: `${this.content.m_title}` },
        { property: "og:site_name", content: "Sentinel Tech" },
        {
          property: "og:description",
          content: `${this.content.m_description}`,
        },
        { property: "og:type", content: "website" },
        {
          property: "og:url",
          content: "https://www.sentineltech.com" + `${this.$route.fullPath}`,
        },
        {
          property: "og:image",
          content:
            "https://www.sentineltech.com/assets/images/TopSectionImage.png",
        },
        {
          property: "twitter:card",
          content: "summary",
        },
        {
          property: "twitter:image",
          content:
            "https://www.sentineltech.com/assets/images/TopSectionImage.png",
        },
        {
          property: "twitter:title",
          content: `${this.content.m_title}`,
        },
        {
          property: "twitter:description",
          content: `${this.content.m_description}`,
        },
        {
          property: "twitter:site",
          content: "@",
        },
      ],
    };
  },
  components: {
    TopMenu,
    Footer,
    HeaderContent,
    ContentBoxWhiteTop,
    ContentBoxBlue,
    ContentBoxGrey,
    ContentBoxWhite,
    ContentBoxWhiteBottom,
    ContentBoxBlueDark,
    ContentBoxCompany,
    ContentBoxWhiteFooter,
  },
  data() {
    return {
      lazybg: {
        position: "center",
        size: "100% 100%",
      },
      isLoading: true,
      formValue: [],
      partners: [
        {
          partner_id: "",
          partner_name: "",
          partner_logo: "",
          partner_url: "",
          sort_partner: "",
        },
      ],
      content: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
        overview: "",
        features: "",
        pricing: "",
        m_title: "Sentinel Tech",
        m_description: "Sentinel Tech",
      },
      contentHeader: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentSubHeader1: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentSubHeader2: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentBookingEngine: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentGoogleWorkspace: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentChannelManager: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentPMS: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentCloudServer: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentNetwork: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      contentCompany: {
        content_id: "",
        content_image: "",
        header_image: "",
        content_title: "",
        content_description: "",
      },
      footer: [],
    };
  },
  watch: {
    $route: "getData",
  },
  created() {
    this.getData();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    async getData() {
      var setLang = 1;
      //console.log(this.$route.params.lang);
      if (typeof this.$route.params.lang === "undefined") {
        setLang = 1;
      } else {
        if (this.$route.params.lang == "en") {
          setLang = 1;
        } else if (this.$route.params.lang == "id") {
          setLang = 2;
        } else {
          setLang = 6;
        }
      }

      await AppService.getContent('content', setLang, 'homepage')
        .then((response) => {
          this.contentHeader = response.content[0];
          this.contentSubHeader1 = response.content[1];
          this.contentSubHeader2 = response.content[2];
          this.contentBookingEngine = response.content[3];
          this.contentGoogleWorkspace = response.content[4];
          this.contentChannelManager = response.content[5];
          this.contentPMS = response.content[6];
          this.contentCloudServer = response.content[7];
          this.contentNetwork = response.content[8];
          this.contentCompany = response.content[9];
          this.footer = [];
          var arr1 = {};
          arr1["title"] = response.content[10].content_title;
          arr1["text"] = response.content[10].content_description;
          arr1["hyperlink"] = "mailto:" + this.$store.state.configs.brand_email;
          arr1["linkname"] = this.$store.state.labels.BTN_GETIN_TOUCH;
          this.footer.push(arr1);
          var arr2 = {};
          arr2["title"] = response.content[11].content_title;
          arr2["text"] = response.content[11].content_description;
          arr2["hyperlink"] = "mailto:" + this.$store.state.configs.brand_email;
          arr2["linkname"] = this.$store.state.labels.BTN_SIGN_UP;
          this.footer.push(arr2);
        })
        .catch((e) => {
          console.log(e)
        })
      await AppService.getPartner('partner')
        .then((response) => {
          this.partners = response.content;
        })
        .catch((e) => {
          console.log(e)
        })
      await AppService.getPageContent('page/homepage', setLang)
        .then((response) => {
          this.content = response.content;
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e)
        })
    },
    contactSales(email) {
      window.location = "mailto:" + email;
    },
    handleResize() {
      if (window.innerWidth < 480) {
        this.lazybg.size = "cover";
      }
    },
  },
};
</script>

<style>
.h-1 {
  height: 1px;
}
</style>
